module.exports = __webpack_public_path__ + "img/blazeofcolor.d345b8c9.png";